<ng-content></ng-content>
<ng-template [cdkPortalOutlet]="mainPortal"></ng-template>
<ng-template [cdkPortalOutlet]="actionsPortal"></ng-template>
<pay-context-bar-dynamic-placeholder
    *ngIf="isDynamic"
></pay-context-bar-dynamic-placeholder>
